import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import { validaSoloNumero } from "../../util/varios";
import CatalogoAlmacen from "../../catalogos/catalogoAlmacen";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableScroll from "../useTableScroll";

const TablaAlmacen = (props) => {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CODIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCION",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "RESPONSABLE",
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let anio = JSON.parse(sessionStorage.getItem("anioactu"));
  const fechaTope = moment(JSON.parse(sessionStorage.getItem("fechasistema")))
    .format("YYYY-MM-DD")
    .replace(anio.toString(), (anio - 18).toString());
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtnregalmacen = JSON.parse(
    sessionStorage.getItem("accbtnregalmacenc")
  );

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtVentas = useRef();
  const txtCodAlmacen = useRef();
  const txtDescripcion = useRef();
  const cmbNacionalidad = useRef();
  const txtCedRes = useRef();
  const cmbSexo = useRef();
  const txtFechaNac = useRef();
  const txtNomResp = useRef();
  const txtApeResp = useRef();
  const txtDireccion = useRef();
  const txtEmail = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();
  const [body, setBody] = useState(null);
  const [activate, setActivate] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [habilitado, setHabilitado] = useState(true);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Almacenes.");

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [catalogoAlmacen, setCatalogoAlmacen] = useState(false);
  const [catalogoPersona, setCatalogoPersona] = useState(false);
  const [operacionPer, setOperacionPer] = useState(0);
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });

  const [records, setRecords] = useState([]);
  const [Stock, setStock] = useState([]);

  const onChange = (e) => {
    if (
      e.target.name === "correoe" ||
      e.target.name === "apellidos" ||
      e.target.name === "direccion" ||
      e.target.name === "nombres" ||
      e.target.name === "descripcion"
    ) {
      /*  e.target.value = e.target.value.toUpperCase(); */
    } else if (
      e.target.name === "nacionalidad" &&
      txtCedRes.current.value !== ""
    ) {
      if (e.target.value !== "") {
        datosRes();
      } else {
        txtCedRes.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      }
    }
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const seleccionarRegistro = () => {
    let campos =
      "idalmacen, trim(descripcion) as descripcion, responsable, ventas";
    let nomtab = "almacen";
    let nomid = "idalmacen";
    let id = txtCodAlmacen.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          txtDescripcion.current.value = "";
          txtVentas.current.checked = false;

          if (response.data !== "") {
            setOperacionPer(0);
            txtDescripcion.current.value = response.data.descripcion.trim();
            cmbNacionalidad.current.value = response.data.responsable
              .trim()
              .substring(0, 1);
            txtCedRes.current.value = response.data.responsable
              .trim()
              .substring(1, 9);
            txtVentas.current.checked = response.data.ventas ? true : false;
            datosRes();
            if (!botones.modificar) {
              setBotones({ ...botones, catalogoper: false });
            }
            seleccionarStock(response.data.idalmacen);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un almacen con este codigo",
              icono: "informacion",
            });
            txtVentas.current.checked = false;
            txtDescripcion.current.value = "";
            cmbNacionalidad.current.value = "";
            txtCedRes.current.value = "";
            cmbSexo.current.value = "";
            txtFechaNac.current.value = "";
            txtNomResp.current.value = "";
            txtApeResp.current.value = "";
            txtDireccion.current.value = "";
            txtEmail.current.value = "";
            txtTlf1.current.value = "";
            txtTlf2.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarAlmacen = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistro();
      }
    }
  };

  const datosRes = () => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let nomid2 = "nacionalidad";
    let id = txtCedRes.current.value;
    let id2 = cmbNacionalidad.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          cmbSexo.current.value = "";
          txtFechaNac.current.value = "";
          txtNomResp.current.value = "";
          txtApeResp.current.value = "";
          txtDireccion.current.value = "";
          txtEmail.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";

          if (response.data !== "") {
            setHabilitadoNU(true);
            setOperacionPer(0);
            cmbSexo.current.value = response.data.sexo;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            txtNomResp.current.value = response.data.nombres;
            txtApeResp.current.value = response.data.apellidos;
            txtDireccion.current.value = response.data.direccion;
            txtEmail.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1;
            txtTlf2.current.value = response.data.tlf2;
            if (!botones.consultar) {
              btnCancela.current.focus();
            } else {
              btnAcepta.current.focus();
            }
          } else {
            txtNomResp.current.focus();
            setOperacionPer(1);
            setHabilitadoNU(false);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (cmbNacionalidad.current.value !== "") {
          datosRes();
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "debe seleccionar la nacionalidad",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
        }
      } else {
        cmbNacionalidad.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      }
    }
  };

  const onCatalogoAlmacen = (values) => {
    setCatalogoAlmacen(false);
    txtCodAlmacen.current.value = values.idalmacen;
    txtVentas.current.checked = values.ventas ? true : false;
    txtDescripcion.current.value = values.descripcion;
    cmbNacionalidad.current.value = values.responsable.substring(0, 1);
    txtCedRes.current.value = values.responsable.substring(1, 8);
    seleccionarStock(values.idalmacen);
    datosRes();
    if (!botones.modificar) {
      setBotones({ ...botones, catalogoper: false });
    }
  };

  const onCatalogoPersona = (values) => {
    setCatalogoPersona(false);
    setHabilitadoNU(true);
    setOperacionPer(0);
    cmbNacionalidad.current.value = values.nacPer;
    txtCedRes.current.value = values.cedPer;
    cmbSexo.current.value = values.sexoPer;
    txtFechaNac.current.value = moment(values.fnacPer).format("YYYY-MM-DD");
    txtNomResp.current.value = values.nomPer;
    txtApeResp.current.value = values.apePer;
    txtDireccion.current.value = values.direPer;
    txtEmail.current.value = values.correoPer;
    txtTlf1.current.value = values.tlf1Per;
    txtTlf2.current.value = values.tlf2Per;
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtDescripcion.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar una descripción al Almacen",
          icono: "informacion",
        });
        txtDescripcion.current.focus();
        sigue = false;
      } else if (txtCedRes.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar la cedula el responsable",
          icono: "informacion",
        });
        txtCedRes.current.focus();
        sigue = false;
      } else if (operacionPer === 1) {
        if (cmbNacionalidad.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar la nacionalidad del responsable",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
          sigue = false;
        } else if (cmbSexo.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar el Sexo del responsable",
            icono: "informacion",
          });
          cmbSexo.current.focus();
          sigue = false;
        } else if (txtFechaNac.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar fecha nacimiento del responsable",
            icono: "informacion",
          });
          txtFechaNac.current.focus();
          sigue = false;
        } else if (txtNomResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el nombre del responsable",
            icono: "informacion",
          });
          txtNomResp.current.focus();
          sigue = false;
        } else if (txtApeResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el apellido del responsable",
            icono: "informacion",
          });
          txtApeResp.current.focus();
          sigue = false;
        } else if (txtDireccion.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar la dirección del responsable",
            icono: "informacion",
          });
          txtDireccion.current.focus();
          sigue = false;
        } else if (txtEmail.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el correo del responsable",
            icono: "informacion",
          });
          txtEmail.current.focus();
          sigue = false;
        } else if (txtTlf1.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el Telefono del responsable",
            icono: "informacion",
          });
          txtTlf1.current.focus();
          sigue = false;
        } else if (txtTlf2.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el Celular del responsable",
            icono: "informacion",
          });
          txtTlf2.current.focus();
          sigue = false;
        }
      }
    }
    if (sigue) {
      var almacen = [];
      var repre = [];
      almacen.push({
        idalmacen:
          txtCodAlmacen.current.value === "" ? 0 : txtCodAlmacen.current.value,
        descripcion: txtDescripcion.current.value.trim(),
        idorganizacion: "1",
        responsable: cmbNacionalidad.current.value + txtCedRes.current.value,
        ventas: txtVentas.current.checked ? true : false,
      });
      repre.push({
        cedula: parseInt(txtCedRes.current.value),
        correoe: txtEmail.current.value.trim(),
        tlf1: txtTlf1.current.value.trim(),
        tlf2: txtTlf2.current.value.trim(),
        apellidos: txtApeResp.current.value.trim(),
        direccion: txtDireccion.current.value.trim(),
        fnacimiento: txtFechaNac.current.value.trim(),
        nacionalidad: cmbNacionalidad.current.value.trim(),
        nombres: txtNomResp.current.value.trim(),
        sexo: cmbSexo.current.value.trim(),
      });

      setBody({
        operacionper: operacionPer,
        almacen: almacen,
        repre: repre,
      });

      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/almacen/actualizar/${ope}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Almacenes.");

    setActivate(false);
    setBody(null);
    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true,
    });
    txtCodAlmacen.current.setAttribute("disabled", true);
    txtCodAlmacen.current.value = "";
    txtDescripcion.current.value = "";
    cmbNacionalidad.current.value = "";
    txtCedRes.current.value = "";
    cmbSexo.current.value = "";
    txtFechaNac.current.value = "";
    txtNomResp.current.value = "";
    txtApeResp.current.value = "";
    txtDireccion.current.value = "";
    txtEmail.current.value = "";
    txtTlf1.current.value = "";
    txtTlf2.current.value = "";
    txtVentas.current.checked = false;
  };

  const cancelar = () => {
    blanquear();
    //props.onHideCancela();
  };

  const cerrar = () => {
    blanquear();
    seleccionarRegistros();
    setVisibleBtn("visible");
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarRegistros = () => {
    let campos = "almacen.*, persona.nombres, persona.apellidos";
    let nomtab = "almacen, persona";
    let condi =
      "persona.cedula = CAST(TRIM(REPLACE(REPLACE(responsable,'V',''),'E','')) AS BIGINT)";
    let orden = "idalmacen";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarStock = (idalmacen) => {
    let endpoint = `${op.conexion}/api/inventario/productoexisselectubi?idalmacen=${idalmacen}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setStock(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {});
  };

  const seleccionarUbicaciones = (almacen) => {
    let campos = "*";
    let nomtab = "ubicacion";
    let condi = "idalmacen = " + almacen;
    let orden = "idubicacion desc";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {});
  };

  const imprimirAlmacen = (tipo) => (e) => {
    e.preventDefault();
    if (
      accbtnregalmacen &&
      accbtnregalmacen.toString().substring(4, 5) === "1"
    ) {
      if (tipo === 1) {
        window.open(
          `${op.reportes}/almacen?afiliado=${afiliado}&reporte=ListaAlmacen`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        window.open(
          `${op.reportes}/productos?afiliado=${afiliado}&reporte=ListaProducto`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (
        accbtnregalmacen &&
        accbtnregalmacen.toString().substring(0, 1) === "1"
      ) {
        setVisibleBtn("collapse");
        setTituloHeader("Incluir Almacenes.");
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoper: false,
        });
        txtCodAlmacen.current.setAttribute("disabled", true);
        setTimeout(() => txtDescripcion.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accbtnregalmacen &&
        accbtnregalmacen.toString().substring(1, 2) === "1"
      ) {
        setVisibleBtn("collapse");
        setTituloHeader("Editar Almacenes.");
        txtCodAlmacen.current.removeAttribute("disabled");
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtCodAlmacen.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accbtnregalmacen &&
        accbtnregalmacen.toString().substring(3, 4) === "1"
      ) {
        setVisibleBtn("collapse");
        setTituloHeader("Eliminar Almacenes.");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtCodAlmacen.current.removeAttribute("disabled");
        txtCodAlmacen.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accbtnregalmacen &&
        accbtnregalmacen.toString().substring(2, 3) === "1"
      ) {
        setVisibleBtn("collapse");
        setTituloHeader("Consultar Almacenes.");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtCodAlmacen.current.removeAttribute("disabled");
        txtCodAlmacen.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn("visible");
      cancelar();
    }
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  return (
    <div className="w-100 h-100">
      <div className="row col-md-12 m-0">
        <div className="row col-md-12 m-0">
          <div className=" col-xl-7 col-lg-7 col-md-12 mx-auto py-5">
            <div className="card px-3 py-3">
              <div className="col-md-12 mx-auto">
                <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between">
                  <div className="col-md-4 col-lg-5">
                    <h3>{tituloHeader}</h3>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end">
                    <a href="/inicio" className="text-light ">
                      <i className="fas fa-times mx-2"></i>
                      <span className="fw-bold">Salir</span>
                    </a>
                  </div>
                </div>
                <div
                  className="border-azul  py-3 rounded"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <div className=" row rounded mx-auto d-flex justify-content-between">
                    <div className="input-group input-group-sm mb-2 col-md-6 col-lg-5 col-sm-4 col-xl-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        CODIGO ALMACEN:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        ref={txtCodAlmacen}
                        disabled
                        onKeyUp={validarAlmacen}
                        onBlur={validarAlmacen}
                        name="idalmacen"
                        className="form-control fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                      <button
                        disabled={botones.catalogo}
                        onClick={() => setCatalogoAlmacen(true)}
                        type="button"
                        className="btn btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                    <div className="form-check form-check-inline col-md-3 p-0 col-sm-4 col-lg-4">
                      <input
                        ref={txtVentas}
                        disabled={habilitado}
                        className="form-check-input py-1"
                        type="checkbox"
                        id="inlineCheckbox1"
                      />
                      <label
                        className="form-check-label px-1"
                        htmlFor="inlineCheckbox1"
                      >
                        VENTAS
                      </label>
                    </div>
                    <div className="input-group input-group-sm mb-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        DESCRIPCION:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        disabled={habilitado}
                        ref={txtDescripcion}
                        onChange={onChange}
                        name="descripcion"
                        className="form-control text-uppercase fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>

                    <div className="col-md-12">
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between">
                        <legend
                          className="float-none w-auto fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Responsable
                        </legend>

                        <div className="input-group input-group-sm mb-2 col-md-6 col-lg-5 col-sm-4 col-xl-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            CEDULA:
                          </label>
                          <select
                            ref={cmbNacionalidad}
                            name="nacionalidad"
                            className="form-select form-select-sm col-3"
                            disabled={habilitado}
                            aria-label=".form-select-sm example"
                            onChange={onChange}
                          >
                            <option value="V">V</option>
                            <option value="E">E</option>
                          </select>
                          <input
                            ref={txtCedRes}
                            autoComplete="off"
                            maxLength={9}
                            type="text"
                            disabled={habilitado}
                            className="form-control fs-6"
                            name="cedula"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={validarPersona}
                            onBlur={validarPersona}
                            onChange={onChange}
                          />
                          <button
                            disabled={botones.catalogoper}
                            type="button"
                            onClick={() => setCatalogoPersona(true)}
                            className="btn btn-success"
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>

                        <div className="input-group input-group-sm mb-2 col-2 mx-auto">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            SEXO:
                          </label>
                          <select
                            ref={cmbSexo}
                            className="form-select form-select-sm"
                            name="sexo"
                            disabled={habilitadoNU}
                            onChange={onChange}
                            aria-label=".form-select-sm example"
                          >
                            <option value="M">M</option>
                            <option value="F">F</option>
                          </select>
                        </div>

                        <div className="input-group input-group-sm mb-2 col-sm-5 col-md-7 col-lg-5 col-xl-5">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            FECHA DE NACIMIENTO
                          </label>
                          <input
                            type="date"
                            ref={txtFechaNac}
                            max={fechaTope}
                            className="form-control text-uppercase fs-6"
                            name="fnacimiento"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            NOMBRES:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtNomResp}
                            name="nombres"
                            className="form-control text-uppercase fs-6"
                            onChange={onChange}
                            aria-label="Sizing example input"
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            APELLIDOS:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtApeResp}
                            name="apellidos"
                            className="form-control text-uppercase fs-6"
                            onChange={onChange}
                            aria-label="Sizing example input"
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-12">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            DIRECCION:
                          </label>
                          <textarea
                            type="area"
                            autoComplete="off"
                            ref={txtDireccion}
                            name="direccion"
                            className="form-control text-uppercase fs-6"
                            onChange={onChange}
                            aria-label="Sizing example input"
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                            style={{ height: 40 }}
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-5">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            EMAIL:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtEmail}
                            className="form-control text-uppercase fs-6"
                            name="correoe"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-pd-220 px-1">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            TELEFONO:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            maxLength={11}
                            ref={txtTlf1}
                            className="form-control fs-6"
                            name="tlf1"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={handleInputNumChange}
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-pd-220 px-2">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            CELULAR:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            maxLength={11}
                            ref={txtTlf2}
                            className="form-control fs-6"
                            name="tlf2"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={handleInputNumChange}
                          />
                        </div>
                      </fieldset>
                    </div>
                    <div className="col-xl-12 mt-2 mx-auto d-flex justify-content-end d-xl-none d-lg-none d-md-block d-sm-block">
                      <button
                        type="button"
                        className="btn btn-sm mx-1 btn-primary rounded-pill"
                        onClick={imprimirAlmacen(1)}
                      >
                        <i className="fas fa-print">
                          Almacenes
                        </i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm mx-1 btn-primary rounded-pill"
                        onClick={imprimirAlmacen(2)}
                      >
                        <i className="fas fa-print">
                          Productos
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 d-flex justify-content-between mt-2">
                  {visibleBtn === "visible" ? (
                    <div className="col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start">
                      <button
                        disabled={botones.incluir}
                        onClick={onBotones(1)}
                        className="btn btn-sm mx-1 btn-primary rounded-pill"
                        title="Incluir Almacen"
                      >
                        <i className="fas fa-plus">
                          {" "}
                          Incluir{" "}
                        </i>{" "}
                      </button>
                      <button
                        disabled={botones.consultar}
                        onClick={onBotones(4)}
                        className="btn btn-sm mx-1 btn-info rounded-pill"
                        title="Consultar Almacen"
                      >
                        <i className="fas fa-eye">
                          Consultar
                        </i>{" "}
                      </button>
                      <button
                        disabled={botones.modificar}
                        onClick={onBotones(2)}
                        className="btn btn-sm mx-1 btn-warning rounded-pill"
                        title="Modificar Almacen"
                      >
                        <i className="fa fa-edit">
                          Modificar
                        </i>{" "}
                      </button>
                      <button
                        disabled={botones.eliminar}
                        onClick={onBotones(3)}
                        className="btn btn-sm mx-1 btn-danger rounded-pill"
                        title="Eliminar Almacen"
                      >
                        <i className="fa fa-trash">
                          Eliminar
                        </i>{" "}
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  {visibleBtn === "visible" ? (
                    ""
                  ) : (
                    <div className="col-md-12 d-flex justify-content-end">
                      <button
                        disabled={botones.aceptar}
                        onClick={onBotones(5)}
                        ref={btnAcepta}
                        className="mx-2 btn btn-sm rounded-pill btn-success"
                      >
                        <i
                          className="fas fa-check-circle"
                        >
                          {" "}
                          Aceptar
                        </i>
                      </button>
                      <button
                        disabled={botones.cancelar}
                        onClick={onBotones(6)}
                        ref={btnCancela}
                        className="mx-2 btn btn-danger btn-sm rounded-pill"
                      >
                        <i
                          className="fas fa-window-close"
                        >
                          {" "}
                          Cancelar
                        </i>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-5 col-lg-5 mx-auto py-5 h-100 d-sm-none d-md-none d-lg-block d-xl-block">
            <div className="col-md-12 mx-auto card">
              <div className="col-md-12 mx-auto h-100 row">
                <div className="row mt-3 mb-3">
                  <h5 className="m-0 titulo-content" style={{ fontSize: 20 }}>
                    Listado de Almacenes
                    <button
                      type="button"
                      className="btn btn-sm btn-primary rounded-pill ml-2"
                      onClick={imprimirAlmacen(1)}
                    >
                      <i className="fas fa-print">
                        {" "}
                        Almacenes
                      </i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary rounded-pill ml-2"
                      onClick={imprimirAlmacen(2)}
                    >
                      <i className="fas fa-print">
                        {" "}
                        Productos
                      </i>
                    </button>
                  </h5>
                </div>
                <div className="col-md-12 mx-auto row mb-3">
                  <TblContainer
                    container={{
                      height: 220,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                      backgroundColor: "white",
                      fontSizeAdjust: "0.6",
                    }}
                  >
                    <TblHead />
                    <TableBody className="overflow-hidden table-bordered">
                      {records &&
                        records.map((item, index) => (
                          <TableRow key={index} style={{ padding: "0" }}>
                            <TableCell
                              className="align-baseBar bg-light"
                              style={{ textAlign: "center", width: "20px" }}
                            >
                              {item.idalmacen}
                            </TableCell>
                            <TableCell
                              className="align-baseline bg-light"
                              style={{ textAlign: "center", width: "80px" }}
                            >
                              {item.descripcion}
                            </TableCell>
                            <TableCell
                              className="align-baseline bg-light"
                              style={{ textAlign: "center", width: "80px" }}
                            >
                              {item.nombres + " " + item.apellidos}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
                <div className="col-md-12 mx-auto row h-100 py-2 px-0 ">
                  <div className="col-md-4 mx-auto d-none d-xl-block">
                    <div className="col-md-12 mx-auto py-2 px-2 card bg-success">
                      <span>Total Ubicaciones:</span>
                      <div className="col-md-12 row mx-auto px-0">
                        <h1 className="col text-right">{records.length} </h1>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mx-auto d-none d-xl-block">
                    <div className="col-md-12 mx-auto py-2 px-2 card bg-info">
                      <span>Productos en Stock:</span>
                      <div className="col-md-12 row mx-auto px-0">
                        <h1 className="col text-right">{Stock.length} </h1>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mx-auto d-none d-xl-block">
                    <div className="col-md-12 mx-auto py-2 px-2 card bg-warning">
                      <span>Total:</span>
                      <div className="col-md-12 row mx-auto px-0">
                        <h1 className="col text-right">0</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CatalogoAlmacen
        show={catalogoAlmacen}
        onHideCancelar={() => setCatalogoAlmacen(false)}
        onHideAceptaCatalogo={onCatalogoAlmacen}
      />
      <CatalogoPersona
        show={catalogoPersona}
        onHideCancelaCatPer={() => setCatalogoPersona(false)}
        onHideAceptaCatPer={onCatalogoPersona}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrar()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
    </div>
  );
};
export default TablaAlmacen;



// WEBPACK FOOTER //
// ./src/components/almacen/nuevaTablaAlmacen.js